<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 28px !important;
}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
</style>
<style lang="scss">
.inputClass-a .el-input__inner {
  height: 28px;
  width: 548px;
}
</style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/sale/order/page" getKey="rows" :isExpand="true" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xiaoshoudingdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehumingcheng')">
            <yi_data_select type="wms_customer" :ids.sync="yt.conditions.wmsCustomerId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')">
            <yi_data_select :max="1" :type="'material2'" :ids.sync="yt.conditions.materialId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('dingdanriqi')">
            <yi_time_input :format="'yyyy-MM-dd'" type="daterange" :start.sync="yt.conditions.orderDateStart" :end.sync="yt.conditions.orderDateEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('kehucaigoudanhao')">
            <el-input maxlength="100" v-model="yt.conditions.customerPurchaseOrderNo"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!--       左侧按钮插槽-->
      <template #buttonsL>
        <el-button
          type="primary"
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, '50%');
            addNew(0);
            setDefaultOption();
          "
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <template #expand="scope">
        <sub_list :sub="scope.row.saleOrderDetailList" :all="scope.row" :colorNoEnable="colorNoEnable"></sub_list>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, '50%', beforeEdit)" v-if="scope.row.status === '0'">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.remove(scope.row, '/web/sale/order/delete')" v-if="scope.row.status === '0'">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" :destroy-on-close="true">
      <!-- 新建送货单 -->
      <template v-if="yt.editObj.action === 'xinzeng' || yt.editObj.action === 'bianji'">
        {{
          $nextTick(() => {
            $refs.yt2.list = addList;
          })
        }}
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
              {{ $t('jibenxinxi') }}
            </div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 0px">
              <el-form-item :label="$t('xiaoshoudingdanhao')" class="noborder" v-if="yt.editObj.no">
                <el-input v-model="yt.editObj.no" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('kehumingcheng')" required>
                <yi_data_select type="wms_customer" :ids.sync="yt.editObj.wmsCustomerId" @change="getItemAddress"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('dingdanleixing')" size="mini" required>
                <yi_dictionary_select :max="1" :type="'WMS_SO_TYPE'" :ids.sync="yt.editObj.soType"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('jiesuanbibie')" size="mini" required>
                <yi_dictionary_select :max="1" :type="'WMS_SO_CURRENCY'" :ids.sync="yt.editObj.currency"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('jiaohuodizhi')">
                <el-input v-model="yt.editObj.shipTo" @input="$forceUpdate()" disabled></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiaohuofangshi')" size="mini" required>
                <yi_dictionary_select :max="1" :type="'WMS_SO_SHIPPING_METHOD'" :ids.sync="yt.editObj.shippingMethod"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('kehucaigoudanhao')" size="mini">
                <el-input :maxlength="100" v-model="yt.editObj.customerPurchaseOrderNo"></el-input>
              </el-form-item>
              <br />
              <el-form-item :label="$t('beizhu')">
                <el-input class="inputClass-a" :maxlength="400" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('shangpinqingdan') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table v-bind="$attrs" :name="$options.name + '2'" ref="yt2" :isRandKey="false" :columns="columnsItem">
              <template #chanpinbianmamingcheng="scope">
                <yi_cross_select :key="scope._index" class="inputClass" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="scope.row.materialId" @getItems="getItems(scope._index, $event)"> </yi_cross_select>
              </template>
              <template #sehao="scope">
                <yi_dictionary_select :max="1" type="CUSTOMER_MATERIAL_COLOR_NO" :ids.sync="scope.row.colorNo" @input="$forceUpdate()"> </yi_dictionary_select>
              </template>
              <template #chanpinguige="scope">
                <el-input class="inputClass" disabled v-model="scope.row.spec"> </el-input>
              </template>
              <template #xiaoshoudanwei="scope">
                <yi_dictionary_select :max="1" :type="'UNIT_CONVERSION_TYPE'" :ids.sync="scope.row.saleUnit" @input="$forceUpdate()"> </yi_dictionary_select>
              </template>
              <template #xiaoshoushuliang="scope">
                <el-input-number class="inputClass" :precision="3" v-model="scope.row.saleQuantity" style="width: 120px" :controls="false" @input="calculateTotalAmount"></el-input-number>
              </template>
              <template #danweihuozhi="scope">
                <el-input-number class="inputClass" :precision="2" v-model="scope.row.price" style="width: 120px" :controls="false" @input="calculateTotalAmount"></el-input-number>
              </template>
              <template #yaohuoriqi="scope">
                <yi_time_input class="inputClass" :format="'yyyy-MM-dd'" type="date" :time.sync="scope.row.requestDate"> </yi_time_input>
              </template>

              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" @click="addNew(scope._index, $event)">
                      {{ $t('xinzengyihang') }}
                    </el-button>
                  </el-col>
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="removeAdd(scope._index, $event)">
                      {{ $t('shanchubenhang') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
          <div style="display: flex; justify-content: flex-start; padding: 10px; color: #F56C6C; font-size: 14px;">
            {{ $t('dingdanzongjiazhi') + ': ' + (totalAmount || 0) + ' ' + (yt.editObj.currency || '') }}
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelCreate()">{{ $t('quxiao') }} </el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/sale/order/insertOrUpdate', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import sub_list from '@@/pages/web/sale_order_management/sale_order/sub/list';
export default {
  name: 'web_sale_order_management_sale_order_list',
  components: { sub_list },
  data() {
    return {
      addList: [],
      editList: [],
      supplierList: [],
      smallNameList: [],
      supplierId: null,
      isShowEditDialog: false,
      rowUnit: null,
      totalAmount: 0,
      colorNoEnable: false,
      columns: [
        {
          label: 'xiaoshoudingdanhao',
          prop: 'no',
          width: 130
        },
        {
          label: 'kehumingcheng',
          prop: 'wmsCustomer.name',
          width: 130
        },
        {
          label: 'dingdanriqi',
          prop: 'orderDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 180
        },
        {
          label: 'dingdanleixing',
          prop: 'soType',
          type: 'dictionary',
          key: 'WMS_SO_TYPE'
        },
        {
          label: 'jiaohuodizhi',
          prop: 'shipTo',
          width: 130
        },
        {
          label: 'jiaohuofangshi',
          prop: 'shippingMethod',
          type: 'dictionary',
          key: 'WMS_SO_SHIPPING_METHOD'
        },
        {
          label: 'danjuzhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'WMS_SO_STATUS'
        },
        {
          label: 'jiesuanzhi',
          prop: 'totalAmount',
          width: 130
        },
        {
          label: 'jiesuanbibie',
          prop: 'currency',
          type: 'dictionary',
          key: 'WMS_SO_CURRENCY'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name',
          width: 180
        },
        {
          label: 'kehucaigoudanhao',
          prop: 'customerPurchaseOrderNo',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
      //编辑
      columnsItem: [
        {
          label: 'paixu',
          prop: 'serialNo',
          width: 60
        },
        {
          label: 'chanpinbianmamingcheng',
          prop: 'materialId',
          type: 'slot',
          wrap: true,
          width: 360,
          isStar: true
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'slot',
          wrap: true,
          width: 130,
          isStar: true,
          show: false
        },
        {
          label: 'chanpinguige',
          prop: 'material.spec',
          type: 'slot',
          wrap: true,
          width: 130
        },
        {
          label: 'xiaoshoudanwei',
          prop: 'saleUnit',
          type: 'slot',
          wrap: true,
          isStar: true,
          width: 130
        },
        {
          label: 'xiaoshoushuliang',
          prop: 'salequantity',
          type: 'slot',
          wrap: true,
          width: 130,
          isStar: true
        },
        {
          label: 'danweihuozhi',
          prop: 'price',
          type: 'slot',
          wrap: true,
          width: 130,
          isStar: true
        },
        {
          label: 'yaohuoriqi',
          prop: 'requestDate',
          type: 'slot',
          wrap: true,
          isStar: true,
          width: 120
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          wrap: true,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    'yt.isShowEditDialog': {
      handler(n) {
        if ((this.yt.editObj.action === 'xinzeng' || this.yt.editObj.action === 'bianji') && n == false) {
          this.addList = [];
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    this.getProductionConfig();
    setTimeout(() => {
      //表格默认按照异常类型编码升序排序。
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        }
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columnsItem.length; i++) {
        const c = this.columnsItem[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    setDefaultOption() {
      this.$set(this.yt.editObj, 'soType', '0');
      this.$set(this.yt.editObj, 'currency', 'OTH');
      this.$set(this.yt.editObj, 'shippingMethod', '1');
    },
    cancelCreate() {
      this.$confirm(this.$t('weibaocundexiaoxijiangbeiqingchu'), this.$t('tishi'), {
        showCancelButton: false,
        confirmButtonText: this.$t('queding'),
        type: 'warning'
      })
        .then(() => {
          this.yt.isShowEditDialog = false;
        })
        .catch(() => {});
    },
    calculateTotalAmount() {
      let total = 0;
      this.addList.forEach(item => {
        if (item.saleQuantity && item.price) {
          total += item.saleQuantity * item.price;
        }
      });
      // 更新 totalAmount，并保留三位小数
      this.totalAmount = total.toFixed(2);
    },
    beforeAdd(params, url) {
      params.saleOrderDetailList = this.addList;
      return params;
    },
    beforeEdit(row) {
      this.addList = row.saleOrderDetailList;
      // 把对象saleOrderDetailList里面material.spec提到上一层
      this.addList.forEach(item => {
        if (item.material && item.material.spec) {
          item.spec = item.material.spec;
        }
      });
      return row;
    },
    takeDelivery() {
      this.isShowEditDialog = true;
    },
    getItemAddress(id, row) {
      if (row) {
        this.yt.editObj.shipTo = row.address;
        this.supplierId = row.id;
      }
    },
    getItems(index, item) {
      this.$set(this.$refs.yt2.list[index], 'saleUnit', item.defaultUnit || '');
      this.$set(this.$refs.yt2.list[index], 'spec', item.spec || '');
    },
    addNew(index, item) {
      // if (this.supplierId === ''||this.supplierId ==null) {
      //     this.utils.errorMessage(this.$t("qingxuanzhegongyingshang"));
      //     return;
      //   }
      const newItem = {
        purchaseOrderId: '',
        no: '',
        codeName: '',
        quantity: '',
        deliveryQuantitySum: '',
        deliveryQuantityResidue: '',
        unit: '',
        deliveryQuantity: '',
        receiveQuantity: '',
        productionDate: '',
        expirationDate: '',
        receiptDate: '',
        remark: ''
      };
      // 插入新行到指定索引下方
      this.addList.splice(index + 1, 0, newItem);

      // 更新所有行的 serialNo
      this.addList.forEach((item, idx) => {
        this.$set(item, 'serialNo', idx + 1); // 根据行的位置更新 serialNo
      });
      // 计算总金额
      this.calculateTotalAmount();
    },
    removeAdd(index, item) {
      // 如果只有一行，不允许删除
      if (this.addList.length === 1) {
        this.utils.errorMessage('无法删除最后一行');
        return;
      }
      this.addList.splice(index, 1);
      // 更新剩余行的 serialNo
      this.addList.forEach((item, index) => {
        this.$set(item, 'serialNo', index + 1);
      });
      // 计算总金额
      this.calculateTotalAmount();
    }
  }
};
</script>
